// Mapping of country codes to currency codes
const countryCurrencyMap = {
  // Eurozone countries
  AT: "EUR",
  BE: "EUR",
  CY: "EUR",
  EE: "EUR",
  FI: "EUR",
  FR: "EUR",
  DE: "EUR",
  GR: "EUR",
  IE: "EUR",
  IT: "EUR",
  LV: "EUR",
  LT: "EUR",
  LU: "EUR",
  MT: "EUR",
  NL: "EUR",
  PT: "EUR",
  SK: "EUR",
  SI: "EUR",
  ES: "EUR",
  // Other countries
  GB: "GBP", // United Kingdom
  CH: "CHF", // Switzerland
  AU: "AUD", // Australia
  NZ: "NZD", // New Zealand
  DK: "DKK", // Denmark
  NO: "NOK", // Norway
  SE: "SEK", // Sweden
  JP: "YEN", // Japan
  HK: "HKD", // Hong Kong
  BR: "BRL", // Brazil
  ZA: "ZAR", // South Africa
  US: "USD", // United States
  CA: "CAD", // Canada
};

function setAutoCurrency() {
  // Check if currency was already set
  const savedCurrency = localStorage.getItem("saved_currency");

  if (savedCurrency) {
    return;
  }

  // Get country from geoip2
  if (typeof geoip2 !== "undefined") {
    geoip2.country(
      (response) => {
        try {
          const countryCode = response.country.iso_code;

          const currencyCode = countryCurrencyMap[countryCode];

          // Check if we have this currency in our exchange rates
          if (currencyCode && window.EXCHANGE.currencies[currencyCode]) {
            window.EXCHANGE.current_currency = currencyCode;
            localStorage.setItem("saved_currency", currencyCode);

            // Update currency display
            const currencyElements = document.querySelectorAll("#selected-currency-desktop, #selected-currency-mobile");
            currencyElements.forEach((el) => {
              el.dataset.cur = currencyCode;
              el.innerText = currencyCode;
            });

            // Update HTML data attribute
            document.querySelector("html").dataset.currency = currencyCode;

            // Force currency update
            if (typeof window.EXCHANGE.run === "function") {
              window.EXCHANGE.run();
            }
          }
        } catch (error) {
          console.error("Error setting auto currency:", error);
          console.error("Error stack:", error.stack);
        }
      },
      (error) => {
        console.error("GeoIP2 error:", error);
        console.error("Error stack:", error.stack);
      }
    );
  } else {
  }
}

// Run after DOM is loaded and EXCHANGE is initialized
document.addEventListener("DOMContentLoaded", () => {
  // Try to wait for EXCHANGE object to be fully initialized
  let attempts = 0;
  const maxAttempts = 10;

  function trySetCurrency() {
    attempts++;

    if (window.EXCHANGE && window.EXCHANGE.currencies) {
      setAutoCurrency();
    } else if (attempts < maxAttempts) {
      setTimeout(trySetCurrency, 1000);
    } else {
    }
  }

  trySetCurrency();
});
